import styled from 'styled-components';

const GalleryTitle = styled.h2`
	background-color: ${(props) => props.theme.colors.white};
	text-align: center;
`;

export default GalleryTitle;
